import type { RequiredGeneric } from '@pba/react-utils';
import { Col, Form, Input, OptionSelect, Row, Select } from 'ui';
import type { VideoStatus } from '../../../models';
import { type VideoSortOption, useVideoSortFilterOptions, useVideoTypeFilterOptions } from './hooks';

export type VideoListFiltersFormValues = {
  search?: string;
  sort?: VideoSortOption;
  type?: VideoStatus;
};

const VideoListFilters = <T extends VideoListFiltersFormValues = never>(_: RequiredGeneric<T>) => {
  const sortOptions = useVideoSortFilterOptions();
  const typeOptions = useVideoTypeFilterOptions();

  return (
    <Row align="middle" gutter="ms" justify="space-between">
      <Col flex="1">
        <Form.Item<VideoListFiltersFormValues> label="Search" name="search">
          <Input hasSearch />
        </Form.Item>
      </Col>

      <Col flex="1">
        <Form.Item<VideoListFiltersFormValues> label="Type" name="type">
          <Select options={typeOptions} />
        </Form.Item>
      </Col>

      <Col flex="1">
        <Form.Item<VideoListFiltersFormValues> label="Sort" name="sort">
          <OptionSelect options={sortOptions} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default VideoListFilters;
